<template>
    <div class="avatars">
        <span v-for="avatar in limitedAvatars" :key="avatar" class="avatar">
            <img :src="avatar" />
        </span>
        <span
            v-if="avatars.length > maxLength"
            class="avatar count has-background-primary has-text-white has-text-centered is-size-6 has-text-weight-bold"
        >
            +{{ avatars.length - maxLength }}
        </span>
    </div>
</template>

<script>
export default {
    props: {
        avatars: {
            type: Array,
            default() {
                return [];
            },
        },
        maxLength: {
            type: Number,
            default: 5,
        },
    },
    computed: {
        limitedAvatars() {
            return this.avatars.slice(this.maxLength);
        },
    },
};
</script>

<style scoped>
.avatars {
    display: inline-flex;
    flex-direction: row;
    padding-left: 50px;
}

.avatar {
    margin-left: -16px;
    position: relative;
    border: 1px solid #fff;
    border-radius: 50%;
    overflow: hidden;
    width: 32px;
    height: 32px;
}

.count {
    display: flex;
    justify-content: center;
    flex-direction: column;
}
.avatar img {
    width: 32px;
    height: 32px;
}
</style>
